import React from 'react';
import { Link } from 'react-router-dom';
import { CtaButtons } from './CtaButtons';
interface PageHeaderProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  /** Visible name of this page in the breadcrumb trail. */
  breadcrumb: string;
  showCta?: boolean;
}

/** Top of every inner page: breadcrumb, the page's single H1, and CTAs. */
export function PageHeader({
  title,
  subtitle,
  breadcrumb,
  showCta = true
}: PageHeaderProps) {
  return <section className="pt-36 sm:pt-40 pb-14 px-4 border-b border-zinc-900 bg-black" data-id="element-284" data-mp="2ynu22evu6e0w">
      <div className="max-w-4xl mx-auto text-center" data-id="element-285" data-mp="2tsokfs9gvlim">
        <nav aria-label="Breadcrumb" className="mb-6" data-id="element-286" data-mp="38fzvlt1ql3i7">
          <ol className="flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-287" data-mp="38hkqxkvvkqh4">
            <li data-id="element-288" data-mp="33mydlc68gnue">
              <Link to="/" className="hover:text-white transition-colors duration-150" data-id="element-289" data-mp="33n6tze1kebac">
                Home
              </Link>
            </li>
            <li aria-hidden="true" className="text-zinc-600" data-id="element-290" data-mp="2azazmfzgwvgq">
              /
            </li>
            <li className="text-gray-300" aria-current="page" data-id="element-291" data-mp="2hxx313mmx4j2">
              {breadcrumb}
            </li>
          </ol>
        </nav>
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tight mb-5" data-id="element-292" data-mp="2lyqsw2jn0tel">
          <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-293" data-mp="2qs1wzvx2ew2t">
            {title}
          </span>
        </h1>
        <div className="h-1 w-24 bg-red-600 mx-auto rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)] mb-6" data-id="element-294" data-mp="1z15k4vb08rfj" />
        <p className="text-lg sm:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-295" data-mp="2327o1pfv9rnu">
          {subtitle}
        </p>
        {showCta && <CtaButtons className="mt-8" data-id="element-296" data-mp="28351xptufzjj" />}
      </div>
    </section>;
}